import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import api from '../../../utils/functions/api';

// resolve user ที่ login อยู่ (state.me.userData._id) -> Employee record ของตัวเอง ผ่าน
// employee.uid (Employee ที่ผูกกับ user login คนนั้น) — ใช้ในหน้า "เช็กอิน" เพื่อรู้ว่า "ฉัน"
// คือพนักงานคนไหน (เทียบกับ owner_id ของแต่ละ opportunity) คืน null ระหว่างรอโหลด/ถ้าไม่มี
// Employee ผูกกับ user คนนี้ (เช่น account admin ที่ไม่มี Employee record จริง)
//
// ยิง GET /employee?uid=...&size=1 ตรงๆ (ไม่ดึงพนักงานทั้งบริษัทมา find เอง) — endpoint นี้ไม่
// กรอง status: 'pending' ออกเวลา query ด้วย uid (ดู employee.service.js#createPipeline) เพราะการ
// เช็กอินสนใจแค่ว่า "มีชื่อเป็นผู้รับผิดชอบ" ของ opportunity ไหม ไม่เกี่ยวกับสถานะ onboarding
export function useMyEmployee() {
  const me = useSelector((state) => state.me);
  const myUserId = me?.userData?._id;
  const [myEmployee, setMyEmployee] = useState(null);

  useEffect(() => {
    if (!myUserId) {
      setMyEmployee(null);
      return undefined;
    }
    let cancelled = false;
    api.get(`${process.env.REACT_APP_API_URL}/employee`, { params: { uid: myUserId, size: 1 } })
      .then(({ data }) => {
        if (!cancelled) setMyEmployee(data?.rows?.[0] || null);
      })
      .catch(() => {
        if (!cancelled) setMyEmployee(null);
      });
    return () => { cancelled = true; };
  }, [myUserId]);

  return myEmployee;
}

export default useMyEmployee;
